// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 0.613281L22 4.27995V22.0007H2V3.00071H11V0.613281ZM20 19.6133V13.7215L13 11.3881V17.2799L20 19.6133ZM20 11.6133V5.72147L13 3.38813V9.27995L20 11.6133Z"}}]};

const Window1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'window-1-filled',
    ref,
    icon: element,
  },
));

Window1FilledIcon.displayName = 'Window1FilledIcon';

export default Window1FilledIcon;
